import { useMutation } from '@tanstack/react-query';
import {
  type VerifyMfaOtpCodeRequestDto,
  verifyTwoFactorIdentityCode,
} from '@/features/user-settings-phone/api';

const useVerifyTwoFactorIdentityCode = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (error: Error) => void;
}) => {
  const mutation = useMutation({
    mutationFn: (data: VerifyMfaOtpCodeRequestDto) => {
      return verifyTwoFactorIdentityCode(data);
    },
    onSuccess,
    onError,
  });

  return {
    verifyPhoneTwoFactor: mutation.mutateAsync,
    isVerifyPhoneTwoFactorLoading: mutation.isPending,
    isVerifyPhoneTwoFactorError: mutation.isError,
    verifyPhoneTwoFactorError: mutation.error,
  };
};

export { useVerifyTwoFactorIdentityCode };
